module.exports = __webpack_public_path__ + "static/about3-872ccb99ca4bad76f96437c9161c19a2.jpg";